'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DirectiveId$() {
  this.c6h = null;
  this.c6i = false;
  this.c6f = null;
  this.c6g = false;
}
export { $c_Lpresto_types$DirectiveId$ as $c_Lpresto_types$DirectiveId$ };
$p = $c_Lpresto_types$DirectiveId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DirectiveId$;
/** @constructor */
function $h_Lpresto_types$DirectiveId$() {
}
export { $h_Lpresto_types$DirectiveId$ as $h_Lpresto_types$DirectiveId$ };
$h_Lpresto_types$DirectiveId$.prototype = $p;
$p.ae4 = (function() {
  if ((!this.c6i)) {
    this.c6h = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j9;
    this.c6i = true;
  }
  return this.c6h;
});
$p.vg = (function() {
  if ((!this.c6g)) {
    this.c6f = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().e1;
    this.c6g = true;
  }
  return this.c6f;
});
var $d_Lpresto_types$DirectiveId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectiveId$, "presto.types$DirectiveId$", ({
  ZE: 1,
  D: 1
}));
export { $d_Lpresto_types$DirectiveId$ as $d_Lpresto_types$DirectiveId$ };
var $n_Lpresto_types$DirectiveId$;
function $m_Lpresto_types$DirectiveId$() {
  if ((!$n_Lpresto_types$DirectiveId$)) {
    $n_Lpresto_types$DirectiveId$ = new $c_Lpresto_types$DirectiveId$();
  }
  return $n_Lpresto_types$DirectiveId$;
}
export { $m_Lpresto_types$DirectiveId$ as $m_Lpresto_types$DirectiveId$ };
//# sourceMappingURL=presto.types$-Directive-Id$.js.map
